export const REPORT_ACCESS_ISSUE_HREF =
  'mailto:Partner360Support@hp.com?subject=Partner%20360%20Cockpit%20access%20inconsistence'
